import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { memo, useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import useViewCheckbook from 'src/hooks/useViewCheckbook';

const GLCode = (props: GridCellProps) => {
  const { isEditMode, hasEditGLCodePermission, isCheckbookEditable, isPeriodView, isYearEditable } =
    useViewCheckbook();
  const { dataItem, dataIndex, field, onChange } = props;
  const { value } = useGridCellDisplayValue(props);
  const { errors, isNewGlCode, isDeleted, warnings } = dataItem;

  const hasEditPermission = useMemo(
    () => (isPeriodView ? isCheckbookEditable : isYearEditable),
    [isCheckbookEditable, isPeriodView, isYearEditable]
  );

  const isEditable = useMemo(
    () => isNewGlCode && isEditMode && hasEditGLCodePermission && !isDeleted && hasEditPermission,
    [hasEditGLCodePermission, hasEditPermission, isDeleted, isEditMode, isNewGlCode]
  );

  const handleTextChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        syntheticEvent: e.syntheticEvent,
        field,
        value: e?.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );
  return (
    <GridCellBase
      {...props}
      title={value.toUpperCase()}
      className={`${
        errors?.glCode?.length || errors?.glCodeFormat?.length
          ? '!bg-error-light'
          : warnings?.glCode?.length
          ? '!bg-warning-light'
          : ''
      } ${props.className}`}
      rowSelectionEnabled
    >
      {isEditable ? (
        <TextInput
          value={value}
          valid={!!value}
          onChange={handleTextChange}
          className="[&>input]:uppercase"
        />
      ) : (
        <span>{value}</span>
      )}
    </GridCellBase>
  );
};

export default memo(GLCode);
